(() => {
  const recommendationSelector = '.product-recommendations, .rj-cart-recommendations';

  function moveRecommendationsAfterFooter() {
    const footer = document.querySelector('body > footer') || document.querySelector('footer');
    if (!footer) return;

    const recommendation = document.querySelector(recommendationSelector);
    if (!recommendation) return;

    const section = recommendation.closest('.shopify-section') || recommendation;

    if (section.dataset.rjAfterFooter === 'true' && section.previousElementSibling === footer) {
      return;
    }

    footer.insertAdjacentElement('afterend', section);
    section.dataset.rjAfterFooter = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveRecommendationsAfterFooter, { once: true });
  } else {
    moveRecommendationsAfterFooter();
  }

  document.addEventListener('shopify:section:load', moveRecommendationsAfterFooter);
  document.addEventListener('shopify:section:reorder', moveRecommendationsAfterFooter);

  const observer = new MutationObserver(() => {
    if (document.querySelector(recommendationSelector) && document.querySelector('footer')) {
      moveRecommendationsAfterFooter();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
